// Module
var code = "<incomplete-addresses></incomplete-addresses>";
// Exports
var _module_exports =code;;
var path = 'app/views/users/gp-letters/tabs/incomplete-addresses/incomplete-addresses.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;